export default __webpack_public_path__ + "static/delegator@2x-6bcb1172facd876d125efed0c0539af8.png";